import { useLocation } from 'react-router-dom'
import qs from 'query-string'

export function useQuery() {
  let { search } = useLocation()
  if (search[0] === '?') search = search.replace(/^\?/, '')
  return qs.parse(search)
}
